$('.hero_slider').slick({
    infinite: true,
    autoplay: true,
    dots: true,
    pauseOnHover: false,
    pauseOnFocus: false,
    autoplaySpeed: 3500,
    speed: 500
});